import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const Counter = observer(class Counter extends React.Component {
  constructor() {
    super();
    this.countdown = this.countdown.bind(this);
  }

  componentWillMount() {
    this.state = {
      counter: null,
      counterClass: ''
    }
  }

  componentDidMount() {
    this.timer = setInterval(this.countdown, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  countdown() {
    const now = moment();
    const expire = moment(this.props.endDate).local();
    const difference = new moment.duration(expire.diff(now));

    let countdown = {};

    countdown.days = difference.days();
    countdown.hours = difference.hours();
    countdown.minutes = difference.minutes();
    countdown.seconds = difference.seconds();

    if(countdown.days <= 0 && countdown.hours <= 0 && countdown.minutes <= 0) {
      this.setState({
        counterClass: 'counter--ending'
      });
    } else {
      this.setState({
        counterClass: ''
      });
    }

    let counter = '';

    Object.keys(countdown).map(
      (key, i) => {
        if(countdown[key] < 0) {
          countdown[key] = 0;
        }

        if(
            (key === 'days' && countdown.days !== 0) ||
            (key === 'hours' && (countdown.days !== 0 || countdown.hours !== 0)) ||
            (key !== 'days' && key !== 'hours')
          ) {
          if(countdown[key] < 10) {
            countdown[key] = `0${countdown[key]}`
          }
          if(counter.length) {
            counter += `:${countdown[key]}`
          } else {
            counter += countdown[key]
          }
        }

        return true;
      }
    )

    this.setState({
      counter
    });
  }

  render() {
    const { translation } = this.props;

    return <span className="counter">{translation.time_remaining}: <strong className={`counter__time ${this.state.counterClass}`}>{this.state.counter}</strong></span>
  }
})

export default translate('Counter')(Counter);


// WEBPACK FOOTER //
// ./src/app/components/Counter/Counter.js